import { addPopupAction, LAYER } from 'js/components/common/PopupManager';

import * as Types from '../types';
import { ChangePasswordPopup } from '../ChangePasswordPopup';

export const showChangePasswordPopupAction = (
    { id, onClose, onSuccess, showOldPassword }: Types.IChangePassPopupProps
) => addPopupAction({
    id,
    onClose,
    onSuccess,
    showOldPassword,
    closeAll: false,
    layer: LAYER.DATA_VERIFICATION,
    component: ChangePasswordPopup
});
